const common = {
  "nav.services": "Services",
  "nav.expertise": "Expertise",
  "nav.about": "About",
  "nav.testimonials": "Testimonials",
  "nav.bookSession": "Book a Session",
  "nav.toggleMenu": "Toggle menu",
  "lang.switchTo": "Español",
  "lang.label": "ES",
  "footer.description": "I empower supply chain professionals and young career starters to build fulfilling, successful careers in Europe through expert guidance and personalised mentoring.",
  "footer.contact": "Contact",
  "footer.quickLinks": "Quick Links",
  "footer.services": "Services",
  "footer.expertise": "Expertise Areas",
  "footer.about": "About Me",
  "footer.testimonials": "Testimonials",
  "footer.bookSession": "Book a Session",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",
  "footer.cookies": "Cookie Policy",
  "footer.copyright": "Mentored by Julen. All rights reserved.",
  "footer.address": "Brussels, Belgium",
  "footer.phone": "+32 473911613",
  "footer.email": "hello@mentoredbyjulen.eu",
};

export default common;